import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./AppBar.css";

export default function AppBar() {
  const [expanded, setExpanded] = useState(false);
  return (
    <header>
      {/* Top Banner Image */}
      <div className="top-banner">
        <img src="/banner.jpg" alt="Organization Banner" />
      </div>

      {/* Navigation Bar */}
      <Navbar
        bg="dark"
        expand="lg"
        variant="dark"
        className="shadow-sm"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Container>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="mx-auto">
              <Nav.Link
                as={NavLink}
                to="/"
                end
                onClick={() => setExpanded(false)}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/About-Us"
                onClick={() => setExpanded(false)}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/Directors"
                onClick={() => setExpanded(false)}
              >
                Directors
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/State-Governing-Body"
                onClick={() => setExpanded(false)}
              >
                State Governing Body
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/Gallery"
                onClick={() => setExpanded(false)}
              >
                Gallery
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/Membership"
                onClick={() => setExpanded(false)}
              >
                Membership
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/Blacklisted-Members"
                onClick={() => setExpanded(false)}
              >
                Blacklist Members
              </Nav.Link>
              <Nav.Link
                href="/MANAV ADHIKAR FORUM.pdf"
                target="_blank" 
                rel="noopener noreferrer" 
                onClick={() => setExpanded(false)}
              >
                By Law
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/Contact-Us"
                onClick={() => setExpanded(false)}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
